<template>
	<div class="group-notice" ref="noticeBox">
		<el-scrollbar v-if="notices.length" class="notice-list" :style="listStyle">
			<div class="notice-item" v-for="notice in notices" :key="notice.id">
				<div class="notice-avatar">
					<head-image :size="56" :name="teamName(notice)" :url="notice.teamAvatar" :is-show-user-info="false"></head-image>
				</div>
				<div class="notice-info">
					<div class="notice-title">
						<span>{{ teamName(notice) }}</span>
						<el-tag size="mini" :type="statusType(notice)">{{ statusText(notice) }}</el-tag>
					</div>
					<div class="notice-text">
						{{ operatorName(notice) }}邀请你加入群聊
					</div>
					<div v-if="notice.postscript" class="notice-postscript">附言：{{ notice.postscript }}</div>
					<div class="notice-time">{{ $date.toTimeText(notice.timestamp) }}</div>
				</div>
				<div class="btn-group">
					<template v-if="isPending(notice)">
						<el-button type="danger" size="mini" :loading="loadingId === rejectKey(notice)" @click="onReject(notice)">拒绝</el-button>
						<el-button type="primary" size="mini" :loading="loadingId === approveKey(notice)" @click="onApprove(notice)">同意</el-button>
					</template>
					<el-button v-else size="mini" @click="markRead(notice)">已读</el-button>
				</div>
			</div>
		</el-scrollbar>
		<no-data-tip v-else class="no-data-tip" :style="listStyle"></no-data-tip>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import NoDataTip from '../common/NoDataTip.vue';

export default {
	name: 'groupNotice',
	components: { HeadImage, NoDataTip },
	data() {
		return {
			listHeight: 600,
			loadingId: ''
		}
	},
	computed: {
		notices() {
			return [...this.groupStore.teamNotices].sort((a, b) => Number(b.timestamp || 0) - Number(a.timestamp || 0));
		},
		listStyle() {
			return `height:${this.listHeight}px`;
		}
	},
	methods: {
		teamName(notice) {
			return notice.teamName || `群聊 ${notice.teamId || ''}`;
		},
		operatorName(notice) {
			return notice.operatorName || notice.operatorAccountId || '有人';
		},
		isPending(notice) {
			return Number(notice.actionStatus || 0) === 0;
		},
		statusText(notice) {
			const status = Number(notice.actionStatus || 0);
			if (status === 1) return '已同意';
			if (status === 2) return '已拒绝';
			if (status === 3) return '已过期';
			return '待处理';
		},
		statusType(notice) {
			const status = Number(notice.actionStatus || 0);
			if (status === 1) return 'success';
			if (status === 2) return 'danger';
			if (status === 3) return 'info';
			return 'warning';
		},
		approveKey(notice) {
			return `approve_${notice.id}`;
		},
		rejectKey(notice) {
			return `reject_${notice.id}`;
		},
		async onApprove(notice) {
			this.loadingId = this.approveKey(notice);
			try {
				const team = await this.$yunxinIM.acceptTeamInvitation(notice);
				this.groupStore.updateTeamNoticeStatus(notice.id, 1);
				if (team) {
					this.$emit('team-joined', team);
				}
				this.$message.success(`已同意加入${this.teamName(notice)}`);
			} catch (error) {
				this.$message.error(error?.message || '同意入群邀请失败');
			} finally {
				this.loadingId = '';
			}
		},
		async onReject(notice) {
			this.loadingId = this.rejectKey(notice);
			try {
				await this.$yunxinIM.rejectTeamInvitation(notice);
				this.groupStore.updateTeamNoticeStatus(notice.id, 2);
				this.$message.success(`已拒绝加入${this.teamName(notice)}`);
			} catch (error) {
				this.$message.error(error?.message || '拒绝入群邀请失败');
			} finally {
				this.loadingId = '';
			}
		},
		async markRead(notice) {
			this.groupStore.setTeamNoticeRead(notice.id);
			await this.$yunxinIM.setTeamJoinActionInfoRead(notice).catch(() => {});
		}
	},
	mounted() {
		this.listHeight = this.$refs.noticeBox.offsetHeight - 20;
	}
}
</script>

<style scoped lang="scss">
.group-notice {
	display: flex;
	flex-direction: column;
	height: 100%;

	.notice-item {
		display: flex;
		align-items: center;
		margin: 0 30px;
		padding: 14px 10px;
		border-bottom: 1px solid #e5e5e5;

		.notice-info {
			flex: 1;
			min-width: 0;
			margin: 0 15px;
			text-align: left;

			.notice-title {
				display: flex;
				align-items: center;
				gap: 8px;
				font-size: 16px;
				font-weight: 600;
				line-height: 28px;
			}

			.notice-text,
			.notice-postscript {
				font-size: 14px;
				line-height: 22px;
				color: var(--im-text-color-secondary);
				word-break: break-all;
			}

			.notice-time {
				font-size: 12px;
				line-height: 20px;
				color: var(--im-text-color-light);
			}
		}

		.btn-group {
			display: flex;
			gap: 8px;
		}
	}
}
</style>
